module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-wrap"
  }, [_c('header', {
    staticClass: "public-head-layout wrapper",
    staticStyle: {
      "width": "1200px"
    }
  }, [_c('div', {
    staticClass: "site-logo index_logo"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/shop',
        query: {
          tab: 1,
          store_id: 1
        }
      }
    }
  }, [_c('img', {
    staticClass: "pngFix",
    attrs: {
      "src": _vm.slogo
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "head-search-bar",
    attrs: {
      "id": "search"
    }
  }, [_c('div', {
    staticClass: "search-form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keywords),
      expression: "keywords"
    }],
    staticClass: "input-text",
    attrs: {
      "name": "namekeyword",
      "id": "namekeyword",
      "type": "text",
      "value": "",
      "maxlength": "60"
    },
    domProps: {
      "value": (_vm.keywords)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keywords = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "input-submit",
    attrs: {
      "type": "button",
      "id": "inquiry",
      "value": "搜索"
    },
    on: {
      "click": _vm.searchBtn
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bc6e5ab"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/self-owned-mall/index/header.vue
// module id = 1544
// module chunks = 1